import compileSymbols from '~/utils/compileSymbols';

var types = [
  'ADD_TEXT',
  'UPDATE_TEXT',
  'UPDATE_FONT',
  'UPDATE_FONT_CATEGORY',
  'FONT_OUTLINE_UNSUPPORTED',
  'REPOSITION_FOR_TEXT_EFFECTS',
  'UPDATE_FONT_HEIGHT',
  'UPDATE_OUTLINE',
  'UPDATE_EFFECT',
  'UPDATE_FIT_TO_DIMENSIONS',
  'UPDATE_LAST_TEXT',
  'VERIFY_DIMENSIONS',
  'VERIFY_ERROR',
  'VERIFY_SUCCESS'
];

export default compileSymbols(types, 'text');
